export default __webpack_public_path__ + "static/media/User_Active.7bc6d277.svg";